/** @format */

import { type App } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createRouterGuards } from './router-guards';
import { notFound, errorRoute } from './static-modules/error';

import outsideLayout from './outside-layout';
import { whiteNameList } from './constant';
import type { RouteRecordRaw } from 'vue-router';
import { PcpLayoutMain } from '@/p-layout';
// import { constantRouterComponents, vueModules } from '@/router/async-modules';

import { useRouterStoreWithOut } from '@/store/modules/router';
import { useMenuStoreWithOut } from '@/store/modules/menu';
import './utils';

const common = [];

// 需要放在所有路由之后的路由
export const endRoutes: RouteRecordRaw[] = [errorRoute, notFound];

export const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'Layout',
		component: PcpLayoutMain,
		meta: {
			title: 'Demo首页',
		},
		children: [],
	},
	// Layout之外的路由
	...outsideLayout,
];

// reset router
export function resetRouter() {
	const routerStore = useRouterStoreWithOut();
	const { router, whiteNameList } = routerStore;
	router.getRoutes().forEach((route) => {
		const { name } = route;
		if (name && !whiteNameList.some((n) => n === name)) {
			router.hasRoute(name) && router.removeRoute(name);
		}
	});
}

export async function setupRouter(app: App) {
	await initRouterStore();
	const routerStore = useRouterStoreWithOut();
	const { router, whiteNameList } = routerStore;

	// 创建路由守卫
	createRouterGuards(router, whiteNameList);

	app.use(router);

	// 路由准备就绪后挂载APP实例
	await router.isReady();
	const menuStore = useMenuStoreWithOut();
	await menuStore.initCurSidebarDisplayMenusAndDynamicRouter();
}

export async function initRouterStore() {
	const routerStore = useRouterStoreWithOut();
	routerStore.setRouter(shallowRef(router));
	routerStore.setRoutes(shallowRef(routes));
	routerStore.setCommonRoutes(common);
	routerStore.setEndRoutes(endRoutes);
	// routerStore.setVueModules(vueModules);
	// routerStore.setConstantRouterComponents(constantRouterComponents);
	routerStore.setWhiteNameList(whiteNameList);
}

export { createRouterGuards };

export const router = createRouter({
	history: createWebHistory(),
	routes,
});
export default router;
